import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appFileUpload]'
})
export class FileUploadDirective {
  @HostBinding('class.fileOver') fileOver: boolean;
  @Output() fileDropped = new EventEmitter<any>();

  // Dragover Listener
  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave Listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    console.log('Drag Leave');
  }

  // Drop Listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
